import { useEffect, memo, useState, useMemo, useRef } from 'react';

const PlaylistAudioPlayer = ({ playlist, play }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const audioRef = useRef(null);

  // useMemo to create a hash of the playlist, so that the useEffect will
  // trigger when the playlist changes, even if the reference to the playlist
  // array is the same (which can happen if the parent component re-renders
  // without changing the playlist)
  const playListHash = useMemo(() => playlist.join('|'), [playlist]);

  useEffect(() => {
    if (playlist.length === 0) return;
    if (currentIndex >= playlist.length) return;

    // Cleanup previous audio instance
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }

    // Create new audio instance for the current track
    const audio = new Audio(playlist[currentIndex]);
    audioRef.current = audio;

    // Handle end of track to play next sequentially
    const handleEnded = () => {
      setCurrentIndex(prev => prev + 1);
    };

    audio.addEventListener('ended', handleEnded);
    if (play) {
      audio.play().catch(error => console.error('Autoplay blocked:', error));
    }

    return () => {
      audio.removeEventListener('ended', handleEnded);
      audio.pause();
    };
  }, [currentIndex, playListHash, play]);

  return null;
};

export default memo(PlaylistAudioPlayer);
